import workImage from '../assets/whyUs/workImage.webp';
import step1Icon from '../assets/whyUs/step1.svg';
import step2Icon from '../assets/whyUs/step2.svg';
import step3Icon from '../assets/whyUs/step3.svg';

export const configWhyUs = {
  sideImage: {
    src: workImage,
    alt: 'Work image',
  },
  steps: [
    {
      id: 'step1',
      title: 'Experienced team',
      subtitle: 'Expertise that drives results',
      description:
        'Our developers, designers, and solution architects bring years of experience across web, mobile, and platform development, ensuring technically robust solutions.',
      icon: step1Icon,
      alt: '1',
    },
    {
      id: 'step2',
      title: 'Scalable & reliable solutions',
      subtitle: 'Built to grow with your business',
      description:
        'We design software that performs efficiently, scales seamlessly, and adapts to your evolving business requirements.',
      icon: step2Icon,
      alt: '2',
    },
    {
      id: 'step3',
      title: 'Transparent communication & support',
      subtitle: 'Partnership you can trust',
      description:
        'We maintain clear communication at every stage and provide long-term support to guarantee project success.',
      icon: step3Icon,
      alt: '3',
    },
  ],
};
